<template>
    <div class="searchIconMain" :style="searchWrapperStyle">
        <div
            class="searchInput"
            :style="searchInputStyle"
        >{{content == '' ? prompt : content}}</div>
        <div class="searchButton" :style="searchButtonStyle">搜索</div>
    </div>
</template>

<script>
export default {
    name: "SearchIcon",

    props: {
        content: {
            type: String,
            default: '',
        },

        prompt: {
            type: String,
            default: '请输入搜索关键词',
        },

        searchWrapperStyle: {
            type: Object,
            default: () => {
                return {}
            },
        },
        
        searchInputStyle: {
            type: Object,
            default: () => {
                return {}
            },
        },

        searchButtonStyle: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },
}
</script>

<style lang="scss" scoped>

//
.searchIconMain {
    width: 100%;
    background: transparent;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    box-sizing: border-box;
    border-radius: $borderRadius;
    background: #ffffff;
    font-size: $fontSizeContent;
    line-height: 2.5em;
}

.searchInput {
    flex-grow: 1;
    font-weight: 800;    
    border-radius: $borderRadius;
    color: $neutralFontMainColor;
    border: transparent;
    box-sizing: border-box;
    padding: 0 0.5em;
    white-space: nowrap;
    overflow: hidden;
    color: #686b73;
}

.searchButton {
    margin-left: 0.5em;
    color: #ffffff;
    text-align: center;
    box-sizing: border-box;
    padding: 0 1em;
    background: linear-gradient(90deg, #1E9EFF, #23AFF2);
    border-radius: $borderRadius;
    flex-shrink: 0;
}

</style>